export const mockFactoryProfiles = [
  {
    id: "fac-001",
    slug: "american-steel-works",
    name: "American Steel Works LLC",
    location: "Columbus, Ohio, USA",
    country: "USA",
    flag: "🇺🇸",
    founded: "1987",
    category: "Garden & Outdoor",
    description: "Family-owned American steel fabrication company specializing in galvanized garden products, outdoor furniture, and heavy-duty storage solutions. All products are manufactured in our Ohio facility using domestic steel.",
    rating: 4.9,
    reviewCount: 3840,
    totalSales: 142000,
    activeResellers: 218,
    responseTime: "< 2 hours",
    verified: true,
    certifications: ["ISO 9001", "Made in USA Certified", "ASTM Compliant"],
    platforms: ["TikTok", "Instagram", "YouTube", "Douyin", "WeChat"],
    commissionRates: {
      TikTok: 15,
      Instagram: 15,
      YouTube: 12,
      Douyin: 18,
      WeChat: 18,
      Twitter: 10,
    },
    defaultCommission: 15,
    minPayout: 50,
    payoutSchedule: "1st of every month",
    coverImage: "https://public.readdy.ai/ai/img_res/35cf7fc2ab5f24046c4100ad5752c802.jpg",
    logo: "https://readdy.ai/api/search-image?query=american%20steel%20works%20company%20logo%20badge%2C%20industrial%20bold%20design%2C%20red%20white%20and%20blue%20colors%2C%20clean%20minimal%20professional%20brand%20mark%2C%20white%20background%2C%20factory%20brand&width=120&height=120&seq=fac-logo-001&orientation=squarish",
    products: [
      {
        id: "fp-asc-001",
        name: "Heavy-Duty Steel Garden Raised Bed Kit 4x8ft",
        slug: "steel-raised-garden-bed-4x8",
        price: 89.99,
        commission: 15,
        totalSales: 9400,
        rating: 4.9,
        image: "https://readdy.ai/api/search-image?query=heavy%20duty%20galvanized%20steel%20raised%20garden%20bed%20kit%204x8%20feet%20assembled%20outdoors%20with%20soil%20and%20plants%2C%20product%20photography%2C%20clean%20white%20background%2C%20professional%20studio%20lighting%2C%20silver%20metal%20finish&width=400&height=300&seq=asc-p1&orientation=landscape",
        warehouse: "USA",
        badge: "Best Seller",
      },
      {
        id: "fp-asc-002",
        name: "Galvanized Steel Wheelbarrow 6 Cu Ft",
        slug: "steel-wheelbarrow-6cuft",
        price: 94.99,
        commission: 15,
        totalSales: 6700,
        rating: 4.8,
        image: "https://readdy.ai/api/search-image?query=heavy%20duty%20galvanized%20steel%20wheelbarrow%206%20cubic%20feet%20with%20pneumatic%20tire%20on%20white%20background%2C%20garden%20equipment%20product%20photography%2C%20professional%20studio%20lighting%2C%20classic%20design%2C%20green%20and%20silver&width=400&height=300&seq=asc-p2&orientation=landscape",
        warehouse: "USA",
        badge: null,
      },
      {
        id: "fp-asc-003",
        name: "Outdoor Firewood Log Rack 4ft Steel",
        slug: "firewood-log-rack-4ft",
        price: 54.99,
        commission: 15,
        totalSales: 6400,
        rating: 4.8,
        image: "https://readdy.ai/api/search-image?query=outdoor%20firewood%20log%20rack%20storage%204%20feet%20wide%20black%20powder%20coated%20steel%20on%20white%20background%2C%20garden%20storage%20product%20photography%2C%20professional%20studio%20lighting%2C%20modern%20design%2C%20with%20cover&width=400&height=300&seq=asc-p3&orientation=landscape",
        warehouse: "USA",
        badge: null,
      },
    ],
  },
  {
    id: "fac-002",
    slug: "golden-prairie-apiary",
    name: "Golden Prairie Apiary",
    location: "Billings, Montana, USA",
    country: "USA",
    flag: "🇺🇸",
    founded: "2003",
    category: "Farm Products & Food",
    description: "Third-generation family beekeeping operation in the heart of Montana's wildflower meadows. We produce raw, unfiltered honey with zero additives. USDA Organic certified. Our honey is harvested once a year at peak bloom.",
    rating: 4.9,
    reviewCount: 8100,
    totalSales: 52000,
    activeResellers: 165,
    responseTime: "< 4 hours",
    verified: true,
    certifications: ["USDA Organic", "Non-GMO Project Verified", "Certified Humane"],
    platforms: ["TikTok", "Instagram", "YouTube", "Douyin", "WeChat"],
    commissionRates: {
      TikTok: 22,
      Instagram: 20,
      YouTube: 18,
      Douyin: 25,
      WeChat: 25,
      Twitter: 15,
    },
    defaultCommission: 22,
    minPayout: 50,
    payoutSchedule: "1st of every month",
    coverImage: "https://readdy.ai/api/search-image?query=beautiful%20montana%20wildflower%20meadow%20with%20beehives%20in%20golden%20afternoon%20light%2C%20aerial%20view%2C%20lush%20green%20fields%2C%20beekeeper%20working%2C%20organic%20honey%20farm%2C%20professional%20photography%2C%20warm%20golden%20tones&width=1200&height=400&seq=fac-cover-002&orientation=landscape",
    logo: "https://readdy.ai/api/search-image?query=golden%20prairie%20apiary%20honey%20farm%20logo%20badge%2C%20honeycomb%20hexagon%20design%2C%20golden%20amber%20colors%2C%20clean%20minimal%20professional%20brand%20mark%2C%20white%20background%2C%20artisan%20honey%20brand&width=120&height=120&seq=fac-logo-002&orientation=squarish",
    products: [
      {
        id: "fp-gpa-001",
        name: "Raw Wildflower Honey 32oz Glass Jar",
        slug: "wildflower-honey-32oz",
        price: 18.99,
        commission: 22,
        totalSales: 34000,
        rating: 4.9,
        image: "https://readdy.ai/api/search-image?query=raw%20wildflower%20honey%20in%20large%20glass%20jar%2032oz%20with%20wooden%20honey%20dipper%20on%20clean%20white%20background%2C%20artisan%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20golden%20amber%20color%2C%20natural%20rustic%20label&width=400&height=300&seq=gpa-p1&orientation=landscape",
        warehouse: "USA",
        badge: "Top Seller",
      },
      {
        id: "fp-gpa-002",
        name: "Organic Clover Honey Bulk 5lb Pail",
        slug: "clover-honey-5lb",
        price: 42.99,
        commission: 22,
        totalSales: 18500,
        rating: 4.8,
        image: "https://readdy.ai/api/search-image?query=organic%20clover%20honey%20bulk%205%20pound%20white%20plastic%20pail%20with%20handle%20on%20white%20background%2C%20wholesale%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20light%20golden%20color%2C%20clean%20label%2C%20american%20beekeeping&width=400&height=300&seq=gpa-p2&orientation=landscape",
        warehouse: "USA",
        badge: "Bulk Deal",
      },
    ],
  },
  {
    id: "fac-003",
    slug: "true-north-maple",
    name: "True North Maple Co.",
    location: "Sherbrooke, Quebec, Canada",
    country: "Canada",
    flag: "🇨🇦",
    founded: "1962",
    category: "Food & Home Goods",
    description: "Quebec's most beloved maple syrup producer, operating for over 60 years in the Eastern Townships. Our sugar bush spans 800 acres of mature maple forest. We also craft artisan soy candles and birch wood kitchenware.",
    rating: 4.9,
    reviewCount: 10200,
    totalSales: 61000,
    activeResellers: 192,
    responseTime: "< 3 hours",
    verified: true,
    certifications: ["Quebec Maple Syrup Producers", "USDA Organic", "Non-GMO", "Rainforest Alliance"],
    platforms: ["TikTok", "Instagram", "YouTube", "Douyin", "WeChat"],
    commissionRates: {
      TikTok: 18,
      Instagram: 18,
      YouTube: 16,
      Douyin: 22,
      WeChat: 22,
      Twitter: 14,
    },
    defaultCommission: 18,
    minPayout: 50,
    payoutSchedule: "1st of every month",
    coverImage: "https://readdy.ai/api/search-image?query=beautiful%20quebec%20maple%20forest%20in%20autumn%20with%20red%20and%20orange%20leaves%2C%20maple%20syrup%20production%20facility%2C%20sugar%20shack%20in%20forest%2C%20professional%20photography%2C%20canada%20fall%20foliage%2C%20warm%20golden%20light&width=1200&height=400&seq=fac-cover-003&orientation=landscape",
    logo: "https://readdy.ai/api/search-image?query=true%20north%20maple%20company%20logo%20badge%2C%20maple%20leaf%20design%2C%20red%20and%20gold%20colors%2C%20clean%20minimal%20professional%20brand%20mark%2C%20white%20background%2C%20canadian%20maple%20syrup%20brand&width=120&height=120&seq=fac-logo-003&orientation=squarish",
    products: [
      {
        id: "fp-tnm-001",
        name: "Pure Maple Syrup Gift Set Grade A 3-Pack",
        slug: "maple-syrup-gift-set",
        price: 34.99,
        commission: 18,
        totalSales: 28000,
        rating: 4.9,
        image: "https://readdy.ai/api/search-image?query=pure%20canadian%20maple%20syrup%20gift%20set%20three%20glass%20bottles%20different%20grades%20on%20white%20background%2C%20food%20product%20photography%2C%20professional%20studio%20lighting%2C%20amber%20golden%20color%2C%20maple%20leaf%20label%2C%20premium%20packaging&width=400&height=300&seq=tnm-p1&orientation=landscape",
        warehouse: "Canada",
        badge: "Best Seller",
      },
      {
        id: "fp-tnm-002",
        name: "Birch Wood End-Grain Cutting Board 18x12in",
        slug: "birch-cutting-board-18x12",
        price: 44.99,
        commission: 16,
        totalSales: 17800,
        rating: 4.9,
        image: "https://readdy.ai/api/search-image?query=large%20birch%20wood%20cutting%20board%2018x12%20inches%20with%20juice%20groove%20on%20white%20background%2C%20kitchen%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20wood%20grain%2C%20end%20grain%20design%2C%20premium%20quality&width=400&height=300&seq=tnm-p2&orientation=landscape",
        warehouse: "Canada",
        badge: null,
      },
      {
        id: "fp-tnm-003",
        name: "Soy Candle Set Cedar and Pine 3-Pack",
        slug: "soy-candle-set-cedar-pine",
        price: 28.99,
        commission: 28,
        totalSales: 15300,
        rating: 4.9,
        image: "https://readdy.ai/api/search-image?query=handcrafted%20soy%20candle%20set%20three%20pack%20cedar%20and%20pine%20scent%20in%20glass%20jars%20on%20white%20background%2C%20home%20decor%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20kraft%20label%2C%20warm%20cozy%20aesthetic&width=400&height=300&seq=tnm-p3&orientation=landscape",
        warehouse: "Canada",
        badge: "High Commission",
      },
    ],
  },
];

export type FactoryProfile = typeof mockFactoryProfiles[0];
